export default __webpack_public_path__ + "static/media/Logo-lightblue-transparent.f23bdf9b.png";